import React, {useState, useEffect} from 'react';

import Alert from '../../alert/alert';
import {loadUser} from '../alert-template-services';

export default ({alert, toggleNotificationRead, closeMenu, push}) => {
    let {ownedBy, label, originList} = alert.event.data;

    let [ownedByUser, setOwnedByUser] = useState();
    useEffect(() => {
        loadUser(ownedBy, setOwnedByUser);
    }, []);
    let originListLink = '/gift-tags/lists/' + originList;

    let message;
    if (ownedByUser) {
        let ownerName = ownedByUser.name.fullName;
        message = <span><b>{ownerName}</b> has marked this gift as no longer received - <b>"{label}"</b></span>
    }
    return (
        <Alert
            alert={alert}
            toggleNotificationRead={toggleNotificationRead}
            link={originListLink}
            closeMenu={closeMenu}
            push={push}
        >
            {message || 'Loading Message...'}
        </Alert>
    );
}